import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import HeaderComp from "./headerFooter/Header";
import FooterComp from "./headerFooter/Footer";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <HeaderComp />
    <App />
    <FooterComp />
  </BrowserRouter>
);
reportWebVitals();
